export const languages = ['Español', 'Portugués', 'Inglés', 'Alemán', 'Chino', 'Italiano']
